import React from 'react';
import { Route, Routes } from 'react-router-dom';
import DiardExpertiseHome from './Home';

function Router() {
  return (
    <Routes>
      <Route exact path="/diardexpertise/home" element={<DiardExpertiseHome />} />
    </Routes>
  );
}

export default Router;
